import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { cn } from "../utils/utils";
import { useAuthState } from "react-firebase-hooks/auth";

import {
  LogOutIcon,
  PlusCircleIcon,
  UsersIcon,
  AlignHorizontalDistributeCenterIcon,
  CandlestickChartIcon,
  LayoutDashboardIcon,
  SettingsIcon,
  SheetIcon,
  BarChartBigIcon,
  ChevronRightCircleIcon,
  ChevronLeftCircleIcon,
  Building,
  Tv,
  Atom,
  FileSpreadsheetIcon,
  CpuIcon,
  AlbumIcon,
  ApertureIcon,
  BoxesIcon,
  ChartColumnIncreasingIcon,
  CalendarIcon,
  SparklesIcon,
} from "lucide-react";
import toast from "react-hot-toast";
import Greek from "../assests/greek.jpeg";
import { auth } from "../Login/firebase";
import Logo from "./logo";

const Icons = {
  dashboard: <LayoutDashboardIcon className="mr-2 h-4 w-4" />,
  live: <AlignHorizontalDistributeCenterIcon className="mr-2 h-4 w-4" />,
  history: <SheetIcon className="mr-2 h-4 w-4" />,
  add: <PlusCircleIcon className="mr-2 h-4 w-4" />,
  chart: <BarChartBigIcon className="mr-2 h-4 w-4" />,
  settings: <SettingsIcon className="mr-2 h-4 w-4" />,
  orders: <SheetIcon className="mr-2 h-4 w-4" />,
  trade: <CandlestickChartIcon className="mr-2 h-4 w-4" />,
  strategyWise: <ApertureIcon className="mr-2 h-4 w-4" />,
  users: <UsersIcon className="mr-2 h-4 w-4" />,
  startegyTable: <Tv className="mr-2 h-4 w-4" />,
  startegy: <Building className="mr-2 h-4 w-4" />,
  greek: <img src={Greek} alt="Greek Logo" className="mr-2 h-4 w-4" />,
  atom: <Atom className="mr-2 h-4 w-4" />,
  vma: <Atom className="mr-2 h-4 w-4" />,
  file: <FileSpreadsheetIcon className="mr-2 h-4 w-4" />,
  data: <CpuIcon className="mr-2 h-4 w-4" />,
  source: <AlbumIcon className="mr-2 h-4 w-4" />,
  stocks: <ChartColumnIncreasingIcon className="mr-2 h-4 w-4" />,
  metrics: <BoxesIcon className="mr-2 h-4 w-4" />,
  cal: <CalendarIcon className="mr-2 h-4 w-4" />,
  alpha: <SparklesIcon className="mr-2 h-4 w-4" />,
};

const sideBarNavItems = [
  {
    title: "Live Position View",
    href: "/live-position-view",
    path: "live-position-view",
    icon: "live",
  },
  {
    title: "Audit",
    href: "/audit",
    path: "audit",
    icon: "file",
  },
  {
    title: "Opportunity Screener",
    href: "/opportunity-screener",
    path: "opportunity-screener",
    icon: "alpha",
  },
  // {
  //   title: "Raw Orders & Positions",
  //   href: "/raw-orders-positions",
  //   path: "raw-orders-positions",
  //   icon: "history"
  // },
  {
    title: "Dashboard",
    href: "/dashboard",
    path: "dashboard",
    icon: "dashboard",
  },
  {
    title: "Live Metrics",
    href: "/live-metrics",
    path: "live-metrics",
    icon: "metrics",
  },
  {
    title: "Order Management",
    href: "/live-positions",
    path: "live-positions",
    icon: "live",
  },
  {
    title: "Source Tags",
    href: "/source-tags",
    path: "source-tags",
    icon: "source",
  },
  // {
  //   title: "Stocks Screener",
  //   href: "/stocks-screener",
  //   path: "stocks-screener",
  //   icon: "stocks",
  // },
  // {
  //   title: "History",
  //   href: "/history",
  //   path: "history",
  //   icon: "history",
  // },

  // {
  //   title: "Straddle table",
  //   href: "/straddle-table",
  //   path: "straddle-table",
  //   icon: "history",
  // },
  // {
  //   title: "Strategy Wise",
  //   href: "/strategy-wise",
  //   path: "strategy-wise",
  //   icon: "strategyWise",
  // },
  {
    title: "Portfolio Analyser",
    href: "/portfolio-analyser",
    path: "portfolio-analyser",
    icon: "chart",
  },
  // {
  //   title: "Pdf to Excel",
  //   href: "/pdf-to-excel",
  //   path: "pdf-to-excel",
  //   icon: "file",
  // },
  // {
  //   title: "SS Strategy",
  //   href: "/ss-strategy",
  //   path: "ss-strategy",
  //   icon: "startegy",
  // },
  // {
  //   title: "Strategy First Table",
  //   href: "/strategy-first-table",
  //   path: "strategy-first-table",
  //   icon: "startegyTable",
  // },
  // {
  //   title: "Strategy",
  //   href: "/strategy-list",
  //   path: "strategy-list",
  //   icon: "atom",
  // },
  {
    title: "Bot Config",
    href: "/bot-config",
    path: "bot-config",
    icon: "atom",
  },
  // {
  //   title: "Greeks",
  //   href: "/greeks",
  //   path: "greeks",
  //   icon: "greek",
  // },
  {
    title: "Alpha Screener",
    href: "/alpha-screener",
    path: "alpha-screener",
    icon: "alpha",
  },
  {
    title: "Data Visulaizer",
    href: "/data-visualizer",
    path: "data-visualizer",
    icon: "data",
  },
  {
    title: "Events Calendar",
    href: "/events-calendar",
    path: "events-calendar",
    icon: "cal",
  },
  {
    title: "TV Options Chart",
    href: "/tv-option-chart",
    path: "tv-option-chart",
    icon: "alpha"
  },
  {
    title: "Commodity Trades",
    href: "/commodity-trades",
    path: "commodity-trades",
    icon: "history"
  },
  {
    title: "SS Greek",
    href: "/developer_access",
    path: "developer_access",
    icon: "greek"
  },
  {
    title: "Relative Strength",
    href: "/relative-strength",
    path: "relative-strength",
    icon: "stocks"
  },
  {
    title: "Clear Stocks",
    href: "/clear-stocks",
    path: "clear-stocks",
    icon: "startegyTable"
  }
];


export function DashboardNav({ isExpanded, toggleExpand }) {
  const path = window.location.pathname;
  const [user] = useAuthState(auth);
  const image = user && user.image;
  const email = user && user.email;

  const userName = user && user.displayName;

  if (!sideBarNavItems?.length) {
    return null;
  }

  return (
    <div
      className={` sticky top-0 hidden md:flex  h-screen  bg-black z-[1000] overflow-visible ${isExpanded ? "w-64" : "w-[55px]"
        } transition-width duration-300 `}
    >
      <aside className="relative max-h-screen  w-full flex-col md:flex space-y-0 py-2 border-r-[1px] border-[#454646]/60">
        <div className="flex  justify-between px-2 py-3">
          <Logo isExpanded={isExpanded} />
        </div>

        <div className="absolute top-1.5 -right-3 z-[100]">
          {isExpanded ? (
            <ChevronLeftCircleIcon
              onClick={toggleExpand}
              className="h-6 w-6 text-white/50 cursor-pointer bg-black rounded-full"
            />
          ) : (
            <ChevronRightCircleIcon
              onClick={toggleExpand}
              className="h-6 w-6 text-white/50 cursor-pointer bg-black rounded-full"
            />
          )}
        </div>

        <nav className={`pt-2 bg-black grid items-start gap-1 w-full`}>
          {sideBarNavItems.map((item, index) => {
            const Icon = Icons[item.icon];
            return (
              item.href && (
                <div key={index}>
                  <Link key={index} to={item.disabled ? "/" : item.href}>
                    <div
                      className={cn(
                        "group flex items-center  px-2 py-2 text-sm border-l-4 text-gray-100 font-medium hover:bg-[#07F2C7]/20 hover:text-gray-300",
                        path.includes(item.path)
                          ? "bg-[#07F2C7]/20 border-l-4 border-[#07F2C7]"
                          : "border-l-4 border-transparent bg-transparent",
                        item.disabled && "cursor-not-allowed opacity-80",
                        isExpanded ? "justify-start" : "justify-center"
                      )}
                    >
                      {Icon}
                      <span>{isExpanded ? item.title : ""}</span>
                    </div>
                  </Link>
                </div>
              )
            );
          })}

          <div className="flex flex-col space-y-4 md:space-y-0 md:flex-row md:justify-between md:px-2 md:pr-4 absolute bottom-4 md:w-full">
            {isExpanded && (
              <div className="flex flex-col space-y-1 items-center md:space-y-0 md:flex-row md:space-x-2">
                <img
                  src={
                    image
                      ? image
                      : "https://t4.ftcdn.net/jpg/02/29/75/83/360_F_229758328_7x8jwCwjtBMmC6rgFzLFhZoEpLobB6L8.jpg"
                  }
                  alt="user"
                  className="h-8 w-8 rounded-md cursor-pointer hover:opacity-50 hover:scale-[0.98] transition duration-200 ease-in-out"
                />
                <div className="flex">
                  <p className="text-xs md:text-sm text-white font-bold font-poppins">
                    {userName || userName?.length > 0
                      ? userName
                      : email?.split("@")[0]}
                  </p>
                </div>
              </div>
            )}
            <button
              onClick={() => {
                auth.signOut();
                toast.success("Logout Successful !!", {
                  duration: 5000,
                });
              }}
              className="border-[1px]  border-gray-600  p-2 rounded-md  "
            >
              <LogOutIcon className="h-4 w-4 text-white" />
            </button>
          </div>
        </nav>
      </aside>
    </div>
  );
}
